(function() {
    'use strict';
    angular
        .module('telestatApp')
        .factory('AdvertisingSourceConversionReport', AdvertisingSourceConversionReport);

    AdvertisingSourceConversionReport.$inject = ['$resource'];

    function AdvertisingSourceConversionReport ($resource) {
        var resourceUrl =  'api/report/advertising-source-conversion/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
